
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_5a145_1x9w7_7",
  "icon-swap": "awsui_icon-swap_5a145_1x9w7_11",
  "icon-swap-copy": "awsui_icon-swap-copy_5a145_1x9w7_16",
  "icon-swap-result": "awsui_icon-swap-result_5a145_1x9w7_29",
  "icon-swap-copied": "awsui_icon-swap-copied_5a145_1x9w7_49",
  "popover-message": "awsui_popover-message_5a145_1x9w7_75",
  "inline-container": "awsui_inline-container_5a145_1x9w7_79",
  "inline-container-trigger": "awsui_inline-container-trigger_5a145_1x9w7_82",
  "inline-container-no-wrap": "awsui_inline-container-no-wrap_5a145_1x9w7_85",
  "text-to-display": "awsui_text-to-display_5a145_1x9w7_94"
};
  